import { AppEnvironment } from '../app/core/models/environment.models';

export const environment: AppEnvironment = {
  production: false,
  version: '0.0.0-dev',
  projectName: 'Diputación de Cáceres',
  // apiBaseUrl: 'http://localhost:8000/api/v1',
  apiBaseUrl: 'https://dev.cms.diputacioncaceres.vrestudio.com/api/v1',
  googleMapsApiKey: 'AIzaSyD27A5PPYpZVDH2JKiM-yozH8bRK_f6HII',
  googleMapsMapId: 'dc1818698f24815e653b09ed',
  auth: {
    enabled: true,
    requireLogin: true,
    enforcePermissions: true,
    loginField: 'email',
  },
  zones: {
    enabled: true,
  },
};
